<template>
  <main-layout>
    <div class="container fluid">
      <template>
        <h3 class="headline">{{ $t('maintenance_service_booking') }}</h3>
        <v-layout wrap>
          <v-flex xs6>
            <v-layout row wrap>
              <v-flex xs6>
                <div class="form-control" style="position: relative">
                  <div class="labelinputontop">Start date</div>
                  <VueCtkDateTimePicker
                    v-model="selectedDate.start"
                    color="#ff706b"
                    locale="en"
                    no-label
                    noClearButton
                    :format="'YYYY-MM-DD HH:mm'"
                    :formatted="'DD/MM/YYYY HH:mm'"
                    @validate="onChangeDate"
                    class="pt-4"
                  />
                </div>
              </v-flex>
              <v-flex xs6 class="pl-2">
                <div class="form-control" style="position: relative">
                  <div class="labelinputontop">End date</div>

                  <VueCtkDateTimePicker
                    v-model="selectedDate.end"
                    color="#ff706b"
                    locale="en"
                    no-label
                    noClearButton
                    :format="'YYYY-MM-DD HH:mm'"
                    :formatted="'DD/MM/YYYY HH:mm'"
                    @validate="onChangeDate"
                    class="pt-4"
                  />
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs6 class="pt-3">
            <div class="text-xs-right">
              <v-btn dark depressed color="primary" @click="isShowFilterDialog = true">
                <v-icon>search</v-icon>&nbsp;{{ $t('advanced search') }}
              </v-btn>
              <v-btn dark outline color="primary" @click="getXlsxData" :loading="loading">
                <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <v-data-table
          :headers="headers"
          :items="data"
          :loading="loading"
          hide-actions
          :pagination.sync="pagination"
          class="elevation-1 mt-4"
        >
          <!-- hide-actions -->
          <template v-slot:items="props">
            <tr>
              <td>{{ getDateFormattedWithTime(props.item.timestamp) }}</td>
              <td>{{ props.item.contact_name }}</td>
              <td>{{ props.item.license_plate_number }}</td>
              <td>{{ props.item.brand }}</td>
              <td>{{ formattedMiles(props.item.mileage) }}</td>
              <td>{{ props.item.contact_tel }}</td>
              <td>{{ props.item.email }}</td>
              <td>
                <span>{{ props.item.store }} </span>
                <span v-if="props.item.branch">สาขา {{ props.item.branch }}</span>
                <span>จังหวัด{{ props.item.province }}</span>
              </td>
              <td>{{ props.item.maintenance_service }}</td>
              <td>{{ props.item.maintenance_other_service || '-' }}</td>
              <td>{{ props.item.maintenance_other_service_detail_order || '-' }}</td>
              <td>{{ props.item.maintenance_other_service_detail || '-' }}</td>
              <td>{{ getDateFormatted(props.item.appointment_date) }}</td>
              <td>{{ getTimeFormatted(props.item.appointment_time_from) }}</td>
              <td>
                <div v-if="props.item.remark">
                  <span>
                    {{ props.item.remark }}
                    <v-btn small flat icon ripple color="primary" @click="onEditRemark(props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </span>
                </div>
                <div v-else>
                  <v-btn small color="primary" @click="onAddRemark(props.item.id)">
                    <v-icon>add</v-icon>
                    {{ $t('secap_add_remark') }}
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>
    </div>

    <v-dialog v-model="isShowFilterDialog" persistent width="600px">
      <v-card class="pa-3">
        <div class="text-xs-right">
          <v-btn fab @click="onClearSearchForm" small flat><v-icon>close</v-icon></v-btn>
        </div>
        <div>
          <v-icon>search</v-icon>&nbsp;
          <h6>{{ $t('advanced search') }}</h6>
        </div>
        <v-layout wrap>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <div>
                <label class="caption">{{ $t('secap_customer_name') }} </label>
              </div>
              <input v-model="filter.contact_name" type="text" />
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <div>
                <label class="caption">{{ $t('secap_car_registration') }}</label>
              </div>
              <input v-model="filter.car_registration" type="text" />
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <div>
                <label class="caption">{{ $t('secap_phone') }}</label>
              </div>
              <input v-model="filter.contact_phone" type="text" />
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <div>
                <label class="caption">{{ $t('secap_service_center') }}</label>
              </div>
              <input v-model="filter.service_center" type="text" />
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <label class="caption">{{ $t('secap_topic') }}</label>
              <multiselect
                v-model="filter.topic"
                :options="topicOptions"
                selectLabel
                selectedLabel
                :allow-empty="true"
                :searchable="false"
                open-direction="top"
              ></multiselect>
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <label class="caption">{{ $t('secap_list_of_repair') }}</label>
              <multiselect
                v-model="filter.subtopic"
                :options="subtopicOptions"
                selectLabel
                selectedLabel
                :allow-empty="true"
                :searchable="false"
                open-direction="top"
              ></multiselect>
            </div>
          </v-flex>
          <v-flex xs12 sm12>
            <div class="form-control pa-1">
              <label class="caption">{{ $t('secap_booking_date') }}</label>
              <DatepickerCustomDialog v-model="filter.appointment_date">
                <input
                  type="text"
                  :value="getDateFormatted(filter.appointment_date)"
                  placeholder="กรุณาเลือกวันที่นัดหมาย"
                  readonly
                />
              </DatepickerCustomDialog>
            </div>
          </v-flex>
          <v-flex xs12 xm12 class="text-xs-center">
            <v-btn @click="onClearSearch" outline color="grey">{{ $t('Clear Search') }}</v-btn>
            <v-btn :loading="loading" @click="onSearch" depressed color="primary">{{
              $t('Search')
            }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="remarkDialog" persistent width="400px">
      <v-card class="pa-3">
        <div class="text-xs-right">
          <v-btn fab @click="onCloseRemarkDialog" small flat><v-icon>close</v-icon></v-btn>
        </div>
        <v-flex xs12 sm12>
          <div class="form-control pa-1">
            <div>
              <label class="caption">{{ $t('secap_remark') }}</label>
            </div>
            <textarea v-model="input.remark" style="width: 100%; height: 100px"></textarea>
          </div>
        </v-flex>
        <v-flex xs12 xm12 class="text-xs-center">
          <v-btn @click="onCloseRemarkDialog" outline color="grey">{{ $t('cancel') }}</v-btn>
          <v-btn :loading="saveloading" @click="onSaveRemark" depressed color="primary">{{
            $t('Save')
          }}</v-btn>
        </v-flex>
      </v-card>
    </v-dialog>
  </main-layout>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import ThaiAddressInput from '@/components/elements/ThaiAddressInput'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Multiselect from 'vue-multiselect'
import XLSX from 'xlsx'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'

export default {
  components: {
    DateFilter,
    ThaiAddressInput,
    DatepickerCustomDialog,
    Multiselect,
    VueCtkDateTimePicker
  },
  data() {
    return {
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      headers: [
        { text: this.$t('secap_timestamp'), value: 'timestamp', sortable: false },
        { text: this.$t('secap_customer_name'), value: 'contact_name', sortable: false },
        { text: this.$t('secap_car_registration'), value: 'license_plate_number', sortable: false },
        { text: this.$t('secap_car_brand'), value: 'brand', sortable: false },
        { text: this.$t('secap_current_miles'), value: 'mileage', sortable: false },
        { text: this.$t('secap_phone'), value: 'contact_tel', sortable: false },
        { text: this.$t('Email'), value: 'email', sortable: false },
        { text: this.$t('secap_service_center'), value: 'store', sortable: false },
        { text: this.$t('secap_topic'), value: 'maintenance_service', sortable: false },
        {
          text: this.$t('secap_list_of_repair'),
          value: 'maintenance_other_service',
          sortable: false
        },
        {
          text: this.$t('secap_subtopic_1'),
          value: 'maintenance_other_service_detail_order',
          sortable: false
        },
        {
          text: this.$t('secap_details'),
          value: 'maintenance_other_service_detail',
          sortable: false
        },
        { text: this.$t('secap_booking_date'), value: 'appointment_date', sortable: false },
        { text: this.$t('secap_booking_time'), value: 'appointment_time_from', sortable: false },
        { text: this.$t('secap_remark'), value: 'remark', sortable: false }
      ],
      data: [],
      loading: false,
      selectedDate: {
        start: moment().subtract(1, 'days').format('YYYY-MM-DD 00:00'),
        end: moment().format('YYYY-MM-DD 23:59')
      },
      isShowFilterDialog: false,
      filter: {
        contact_name: '',
        car_registration: '',
        contact_phone: '',
        service_center: '',
        topic: '',
        subtopic: '',
        appointment_date: ''
      },
      remarkDialog: false,
      input: {
        orderId: '',
        remark: ''
      },
      topicOptions: ['เช็คระยะ/ถ่ายน้ำมันเครื่อง', 'รายการซ่อมบำรุงอื่นๆ โปรดระบุ'],
      subtopicOptions: [
        'แบตเตอร์รี่/ไดร์สตาร์ท',
        'ระบบทำความเย็น/แอร์รถยนต์',
        'ระบบไฟส่องสว่างต่างๆ',
        'ไฟเตือน',
        'ก้าน+ใบปัดน้ำฝน',
        'ผ้าเบรค/ระบบเบรค',
        'คลัทช์',
        'ช่วงล่าง รองรับน้ำหนักต่างๆ ',
        'ยาง',
        'ประตู',
        'ระบบไฟฟ้าและอุปกรณ์ภายใน',
        'พวงมาลัย',
        'อุปกรณ์เสริมต่างๆ'
      ],
      saveloading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getXlsxData() {
      let vm = this
      vm.isExport = true
      vm.offset = 0
      const data = await vm.getData()
      vm.isExport = false
      vm.onRefresh()

      const store = data.map((el) => {
        let store_name = `${el.store} จังหวัด${el.province}`
        return {
          timestamp: vm.getDateFormattedWithTime(el.timestamp),
          contact_name: el.contact_name,
          license_plate_number: el.license_plate_number,
          brand: el.brand,
          mileage: el.mileage,
          contact_tel: el.contact_tel,
          email: el.email,
          store: store_name,
          maintenance_service: el.maintenance_service,
          maintenance_other_service: el.maintenance_other_service
            ? el.maintenance_other_service
            : '-',
          maintenance_other_service_detail_order: el.maintenance_other_service_detail_order
            ? el.maintenance_other_service_detail_order
            : '-',
          maintenance_other_service_detail: el.maintenance_other_service_detail
            ? el.maintenance_other_service_detail
            : '-',
          appointment_date: vm.getDateFormatted(el.appointment_date),
          appointment_time: vm.getTimeFormatted(el.appointment_time_from),
          remark: el.remark ? el.remark : '-'
        }
      })

      let Heading = [
        [
          `${this.$t('secap_timestamp')}`,
          `${this.$t('secap_customer_name')}`,
          `${this.$t('secap_car_registration')}`,
          `${this.$t('secap_car_brand')}`,
          `${this.$t('secap_current_miles')}`,
          `${this.$t('secap_phone')}`,
          `${this.$t('Email')}`,
          `${this.$t('secap_service_center')}`,
          `${this.$t('secap_topic')}`,
          `${this.$t('secap_list_of_repair')}`,
          `${this.$t('secap_subtopic_1')}`,
          `${this.$t('secap_details')}`,
          `${this.$t('secap_booking_date')}`,
          `${this.$t('secap_booking_time')}`,
          `${this.$t('secap_remark')}`
        ]
      ]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, Heading)
      XLSX.utils.sheet_add_json(ws, store, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `maintenance-service-booking.xlsx`)
    },
    getData() {
      return new Promise((resolve) => {
        const vm = this
        let limit = vm.isExport ? vm.total : vm.limit

        let data = {
          pageid: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset,
          start_date: moment(vm.selectedDate.start).format('YYYY-MM-DD HH:mm'),
          end_date: moment(vm.selectedDate.end).format('YYYY-MM-DD HH:mm')
        }

        if (vm.filter.contact_name) {
          Object.assign(data, { contact_name: vm.filter.contact_name })
        }
        if (vm.filter.car_registration) {
          Object.assign(data, { license_plate_number: vm.filter.car_registration })
        }
        if (vm.filter.contact_phone) {
          Object.assign(data, { contact_tel: vm.filter.contact_phone })
        }
        if (vm.filter.service_center) {
          Object.assign(data, { store: vm.filter.service_center })
        }
        if (vm.filter.topic) {
          Object.assign(data, { maintenance_service: vm.filter.topic })
        }
        if (vm.filter.subtopic) {
          Object.assign(data, { maintenance_other_service_detail: vm.filter.subtopic })
        }
        if (vm.filter.appointment_date) {
          Object.assign(data, { appointment_date: vm.filter.appointment_date })
        }

        vm.loading = true
        api.getSecapMaintenanceReservation(data, (err, response) => {
          vm.loading = false

          if (err) {
            console.error(err)
            return
          }

          if (response.responsecode == 200) {
            vm.data = response.data
            vm.total = response.total
            resolve(response.data)
          }
        })
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    onChangeDate() {
      this.onRefresh()
    },
    getDateFormatted(val) {
      return val ? moment(val).format('DD/MM/YYYY') : ''
    },
    getDateFormattedWithTime(val) {
      return val ? moment(val).format('DD/MM/YYYY HH:mm') : ''
    },
    getTimeFormatted(val) {
      const parts = val ? val.split(':') : ''
      return val ? `${parts[0]}:${parts[1]}` : 'Invalid time'
    },
    onRefresh() {
      this.pageNumber = 1
      this.limit = 10
      this.offset = 0
      this.getData()
    },
    onSearch() {
      this.onRefresh()
      this.isShowFilterDialog = false
    },
    onClearSearchForm() {
      this.filter = {
        contact_name: '',
        car_registration: '',
        contact_phone: '',
        service_center: '',
        topic: '',
        subtopic: '',
        appointment_date: ''
      }
      this.isShowFilterDialog = false
    },
    onClearSearch() {
      this.onClearSearchForm()
      this.onRefresh()
    },
    onAddRemark(id) {
      this.input.orderId = id
      this.remarkDialog = true
    },
    onEditRemark(item) {
      this.input = {
        orderId: item.id,
        remark: item.remark
      }
      this.remarkDialog = true
    },
    onCloseRemarkDialog() {
      this.input = {
        orderId: '',
        remark: ''
      }
      this.remarkDialog = false
    },
    onSaveRemark() {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        id: vm.input.orderId,
        remark: vm.input.remark
      }

      vm.saveloading = true
      api.updateSecapRemark(data, (err, response) => {
        vm.saveloading = false
        if (err) {
          console.error(err)
          return
        }
        if (response.responsecode == 200) {
          vm.onCloseRemarkDialog()
          vm.getData()
        }
      })
    },
    formattedMiles(val) {
      return val ? Number(val).toLocaleString() : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.labelinputontop {
  position: absolute;
  top: 0 !important;
  left: 0 !important;
  font-size: 14px;
  color: #8c8c8c;
  text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/secap/MaintenanceServiceBooking.vue